import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFinancialHealthinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.15,
			d: "M.9 12.78a8.1 8.1 0 0 1 16.2 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.15,
			d: "M3.6 12.78a5.4 5.4 0 0 1 10.8 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.15,
			d: "M6.3 12.78a2.7 2.7 0 0 1 5.4 0"
		})
	]
});
export default SvgFinancialHealthinline;
